// shadcn/ui sonner (CLI 4.21.0) — the kit's Toast. Changed from upstream:
// no next-themes (light and dark follow the system through the tokens),
// sonner's own look switched off (`unstyled`) and rebuilt from tokens, and
// the icons carry the meaning in the status colours and nothing else.
import { CircleCheckIcon, InfoIcon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner } from "sonner";
import type { ToasterProps } from "sonner";

function Toaster(props: ToasterProps) {
  return (
    <Sonner
      position="bottom-right"
      icons={{
        success: <CircleCheckIcon className="size-4 text-success" />,
        info: <InfoIcon className="size-4 text-muted-foreground" />,
        warning: <TriangleAlertIcon className="size-4 text-warning" />,
        error: <OctagonXIcon className="size-4 text-destructive" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "glass flex w-full items-start gap-3 rounded-card p-4 text-body text-popover-foreground shadow-pop",
          title: "font-semibold",
          description: "text-muted-foreground",
          actionButton:
            "ml-auto h-control-sm shrink-0 cursor-pointer rounded-control bg-primary px-3 font-semibold text-primary-foreground",
          cancelButton:
            "h-control-sm shrink-0 cursor-pointer rounded-control bg-fill px-3 font-medium text-foreground",
          icon: "mt-0.5",
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
